import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import css from './RequestDemoPopUp.css';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { enterpriseRequestDemo, setGotoBlockAutoplayValue } from '../../custom-ducks/utility.duck';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { notifySuccess } from '../../components/HotToast/HotToastProvider';
import { POPUP_OVERLAY_STYLE, popupContentStyle } from '../../components/PopupShell/reactjsPopupStyles';

const RequestDemoPopUp = props => {
  const { trigger, onRequestDemo, onSetGotoBlockAutoplayValue } = props;
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [company, setCompany] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  return (
    <Popup
      closeOnDocumentClick={false}
      contentStyle={popupContentStyle({ width: '480px', maxWidth: '92vw' })}
      overlayStyle={POPUP_OVERLAY_STYLE}
      trigger={trigger}
      modal
      onOpen={() => onSetGotoBlockAutoplayValue(false)}
      onClose={() => onSetGotoBlockAutoplayValue(true)}
      lockScroll
    >
      {close => {
        const onSubmit = () => {
          onRequestDemo({
            firstName,
            lastName,
            company,
            email,
            phoneNumber,
          }).then(() => {
            notifySuccess('Demo Request Sent');
          });

          close();
        };

        return (
          <div className={css.base}>
            <div className={css.header}>
              <FontAwesomeIcon onClick={close} className={css.closeIcon} icon={faTimes} />
              <p className={css.title}>Request a demo</p>
              <p className={css.subTitle}>
                Tell us a bit about yourself and we'll be in touch to schedule a
                walkthrough.
              </p>
            </div>
            <div className={css.body}>
              <label className={css.fieldLabel}>First Name</label>
              <input
                className={css.input}
                value={firstName}
                onChange={event => setFirstName(event.target.value)}
              />

              <label className={css.fieldLabel}>Last Name</label>
              <input
                className={css.input}
                value={lastName}
                onChange={event => setLastName(event.target.value)}
              />

              <label className={css.fieldLabel}>Company</label>
              <input
                className={css.input}
                value={company}
                onChange={event => setCompany(event.target.value)}
              />

              <label className={css.fieldLabel}>Email</label>
              <input
                className={css.input}
                value={email}
                onChange={event => setEmail(event.target.value)}
              />

              <label className={css.fieldLabel}>Phone number</label>
              <input
                className={css.input}
                value={phoneNumber}
                onChange={event => setPhoneNumber(event.target.value)}
              />

              <div className={css.actions}>
                <div onClick={close} className={css.button}>
                  Cancel
                </div>
                <div onClick={onSubmit} className={css.filledButton}>
                  Submit
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </Popup>
  );
};

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    onRequestDemo: data => dispatch(enterpriseRequestDemo(data)),
    onSetGotoBlockAutoplayValue: shouldGotoBlockAutoplay =>
      dispatch(setGotoBlockAutoplayValue(shouldGotoBlockAutoplay)),
  };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(RequestDemoPopUp);
